module.exports = __webpack_public_path__ + "static/img/050601.23260c7b.png";